export enum DimensionRowLevel {
  OBSTACLE = 0,
  BOUNDS = 1,
  ROW_2 = 2,
  ROW_3 = 3,
  ROW_4 = 4,
}
